import GeneralTracker from '../GeneralTracker';


export default class FiltersTracker extends GeneralTracker {
  STORAGE_KEY = 'trackingFiltersKey';
  CAPTURE_NAME = 'ui:directory:filters:usage';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();

    service.on('changeFilters', this.onChangeFilters);
    service.on('resetFilters', () => this.passthrough({ action: 'reset' }));
    service.on('applyFilters', () => this.passthrough({ action: 'apply' }));
    service.on('saveFilters', (payload) => this.passthrough({
      action: 'save',
      tags: payload,
    }));
    service.on('toggleFiltersSidebar', this.passthrough);
    service.on('usePopularFilters', (payload) => {
      this.setInfo({ popularFilter: payload });
    });
    service.on('startApplyFilters', () => {
      this.setInfo({ applyButtonUsed: 0 });
    });
    service.on('endApplyFilters', () => {
      this.setInfo({ applyButtonUsed: 1 });
    });

    service.on('applyFavoriteFilters', (payload) => {
      this.setInfo({
        savedFilterUsed: {
          gender: payload.filters[0],
          name: payload.collection.text,
          value: payload.collection.value,
        },
      });
    });
  }

  onChangeFilters = (payload) => {
    const info = this.getInfo();

    const { old, current } = payload;
    const diff = (a, b) => a.filter((v) => !b.includes(v));
    const symDiff = (a, b) => diff(a, b).concat(diff(b, a));

    const reset = info?.resetButtonUsed === 1;

    let tags = { old, current, reset, apply: false };
    tags.source = info?.popularFilter ? 'popular' : 'sidebar';

    if (info?.applyButtonUsed === 0) {
      const temp = (old === undefined || old.length === 0) ? { current } : { old };

      this.setInState('applyDetails', temp);
      this.clearInfo();

      return;
    } else if (info?.applyButtonUsed === 1) {
      const temp = this.getFromState('applyDetails');
      this.deleteFromState('applyDetails');

      tags = {
        ...tags,
        ...temp,
        apply: true,
      };
    }

    if (info?.savedFilterUsed !== undefined) {
      tags.savedFilter = info.savedFilterUsed;
      tags.source = 'favorite';
    }

    tags.old = tags.old === undefined ? [] : tags.old;
    tags.current = tags.current === undefined ? [] : tags.current;
    let total = 0;

    if (tags.old.length < tags.current.length) {
      tags.type = 'add';

      tags.changed = diff(tags.current, tags.old);
      total = tags.old.length + tags.changed.length;
      if (total !== tags.current.length) {
        tags.type = 'replace';
      }
    } else if (tags.old.length > tags.current.length) {
      tags.type = 'remove';

      tags.changed = diff(tags.old, tags.current);
      total = tags.current.length + tags.changed.length;
      if (total !== tags.old.length) {
        tags.type = 'replace';
      }
    } else {
      tags.type = 'noop';

      tags.changed = [];
      if (tags.old.filter((item) => !tags.current.includes(item)).length) {
        tags.type = 'replace';
        tags.changed = symDiff(tags.current, tags.old);
      }
    }

    tags.removed = diff(tags.old, tags.current);
    tags.added = diff(tags.current, tags.old);

    tags.lengths = {
      old: tags.old.length,
      current: tags.current.length,
      changed: tags.changed.length,
      removed: tags.removed.length,
      added: tags.added.length,
    };

    const trackPayload = {
      action: 'change',
      tag: tags,
    };

    if (info !== undefined) {
      trackPayload.info = info;
    }

    this.track(trackPayload);
    this.clearInfo();
  };

  trackResetFiltersEvents = () => {
    this.setInfo({ resetButtonUsed: 1 });
    this.track({ action: 'reset' });
  };

  passthrough(name, payload) {
    switch (name) {
      case 'resetFilters':
        super.passthrough(name, { action: 'reset' });
        break;

      case 'toggleFiltersSidebar':
        super.passthrough(name, payload);
        break;

      default:
    }
  }
}
